import { Card } from '../ui/card';

export const ChartContainer = ({ 
  title, 
  subtitle,
  children, 
  className = '',
  action
}) => {
  return (
    <Card 
      className={`p-6 border-white/5 bg-card/90 backdrop-blur-sm ${className}`}
      data-testid="chart-container"
    >
      <div className="flex items-start justify-between mb-6">
        <div>
          <h3 className="text-lg font-playfair font-medium text-foreground tracking-tight">
            {title}
          </h3>
          {subtitle && (
            <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        {action && (
          <div className="flex items-center gap-2">
            {action}
          </div>
        )}
      </div>
      <div className="w-full">
        {children}
      </div>
    </Card>
  );
};

// Custom tooltip for recharts
export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-card border border-primary/30 rounded-lg p-3 shadow-xl backdrop-blur-sm">
        <p className="text-xs text-muted-foreground mb-2 font-manrope">{label}</p>
        {payload.map((entry, index) => (
          <div key={index} className="flex items-center gap-2">
            <div 
              className="w-2 h-2 rounded-full" 
              style={{ backgroundColor: entry.color }}
            />
            <span className="text-sm font-manrope text-foreground">
              {entry.name}: <span className="font-semibold">{entry.value.toLocaleString()}</span>
            </span>
          </div>
        ))}
      </div>
    );
  }
  return null;
};
